import { render } from "./HelpVideoEditItem.vue?vue&type=template&id=5384d5f6"
import script from "./HelpVideoEditItem.vue?vue&type=script&lang=js"
export * from "./HelpVideoEditItem.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import BaseInput from "@/components/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseConfirmModal from "@/components/BaseConfirmModal.vue";
script.components = Object.assign({}, { BaseInput, BaseButton, BaseConfirmModal }, script.components);